/**
 * Enhanced LanguageLink component with Google Analytics tracking
 */

import { LanguageLink as BaseLanguageLink } from '@/components/LanguageLink';
import { trackNavigation } from '@/lib/analytics';
import type { ComponentProps } from 'react';

interface AnalyticsLanguageLinkProps extends ComponentProps<typeof BaseLanguageLink> {
  trackingCategory?: string;
}

export const AnalyticsLanguageLink = ({
  to,
  trackingCategory = 'navigation',
  onClick,
  children,
  ...props
}: AnalyticsLanguageLinkProps) => {

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    // Track navigation based on the destination
    const path = typeof to === 'string' ? to : '';

    if (path.includes('/dashboard')) {
      trackNavigation.dashboard();
    } else if (path.includes('/videos')) {
      trackNavigation.videos();
    } else if (path.includes('/account')) {
      trackNavigation.account();
    } else if (path === '/' || path.includes('/?')) {
      trackNavigation.landing();
    }

    // Call original onClick if provided
    onClick?.(event);
  };

  return (
    <BaseLanguageLink to={to} onClick={handleClick} {...props}>
      {children}
    </BaseLanguageLink>
  );
};